


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { FilterDropdwonOption } from './FilterDropdown.vue';

@Component({
  components: {},
})
export default class FilterDropdownItem extends Vue {
  @Prop({ required: true })
  options: FilterDropdwonOption[];

  @Prop({ required: true })
  updateValue: (option: number | string) => string;

  @Prop({ required: true })
  isMultiSelection: boolean;

  @Prop({ required: true })
  optionClick: (option: FilterDropdwonOption, hide: () => void) => void;

  @Prop({ default: null })
  hide: () => void;
}
